"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    rpc: {},
    types: {
        CollectionId: 'u64',
        NFTClassId: 'u32',
        ClassIdOf: 'ClassId',
        TokenIdOf: 'TokenId',
        GroupCollectionId: 'u64',
        ClassInfoOf: {
            metadata: 'Vec<u8>',
            totalIssuance: 'TokenId',
            owner: 'AccountId',
            data: 'NftClassData'
        },
        CollectionType: {
            _enum: ['Collectable', 'Wearable', 'Executable']
        },
        TokenInfoOf: {
            metadata: 'Vec<u8>',
            owner: 'AccountId',
            data: 'NftAssetData'
        },
        NftAssetData: {
            deposit: 'Balance',
            name: 'Vec<u8>',
            description: 'Vec<u8>',
            properties: 'Vec<u8>'
        },
        NftClassData: {
            deposit: 'Balance',
            properties: 'Vec<u8>',
            tokenType: 'TokenType',
            collectionType: 'CollectionType',
            totalSupply: 'u64',
            initialSupply: 'u64'
        },
        NftCollectionData: {
            name: 'Vec<u8>',
            owner: 'AccountId',
            properties: 'Vec<u8>'
        },
        TokenType: {
            _enum: ['Transferable', 'BoundToAddress']
        }
    },
    typesAligns: {
        nft: {
            ClassId: 'NFTClassId'
        }
    }
};
